import UserPermissionsManager from './UserPermissionsManager';

export default UserPermissionsManager;
